import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class HtmlViewerAPI extends ComponentAPI {
}
export default HtmlViewerAPI;
//# sourceMappingURL=html-viewer-api.js.map